import React, { Fragment } from 'react';

import { connect } from 'react-redux';
import { AppState, Actions, store, PanelState, minDaysLater, IPageState } from '../appredux';

import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import green from '@material-ui/core/colors/green';
import { Grid, Paper, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core';
import Gallery from './common/gallery'
import Details from './Details'
import { withStyles, WithStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';
import { webRoomDetails } from '../api';

import CONFIG from '../cfg/config';
import { fontSelect } from '../fonts';

import roomImg from 'app/assets/noImage.jpg';
import themeBlue from '../themes/themesBlue';

import { toIloswWAndData, getDate } from 'app/common/ReservationHelpers';
import { selectTheme } from './common/helpers';
import { Padding } from '@mui/icons-material';
import * as M from '@material-ui/core';

const themeBlueRed = M.createTheme({
  //  palette: appPalette,
  palette: {
    primary: { light: "rgba(58, 135, 173, 0.5)", main: "#3a87ad", dark: "#005a7e" },
    //secondary: { light: "rgb(232, 240, 254)", main: "rgb(244, 67, 54)", dark: "#005a7e" },
    secondary: {  main: "rgb(244, 67, 54)" },
    error: { main: "rgb(244, 67, 54)" },
    text: { secondary: "#555" }
  },
})

//PM 2021-07-12
export interface Room {
  minIloscDni: string;
  id: number | string;
  rodzPokoi: string;
  pokoj: number;
  cena: string;
  iloscMiejsc: string;
  galleryRodzPokoi: string;
  opis: string;
  info: string;
  ktoraCenaOpis: string;
}

//PM 2021-07-12
interface RoomCardProp {
  key: number,
  room: Room,
  //lang?: string,
  //dateFrom: string,
  //dateTo: string,
  page: IPageState,
  pokoje_dostepne: boolean,
  windowWidth: number,  
  //kolorTla: string
  borderLeft: string,
  podstrona?: number
}

type RoomCardState = {
  price: number,
  expanded: boolean,
  details: webRoomDetails,
  //dostepnosc: dostepnoscPokoju,
  openDetails: boolean,
  openError: boolean,
  visible: boolean,
}

class RoomCard extends React.Component<RoomCardProp & WithTranslation & WithStyles<typeof styles> & TransProps, RoomCardState> {
  avatar: any;
  textTheme = fontSelect(6, 2) as React.CSSProperties;

  constructor(props: RoomCardProp & WithTranslation & WithStyles<typeof styles> & TransProps) {
    super(props, {});
    this.avatar = <span />;
    this.state = {
      price: 0.0,
      expanded: false,
      details: new webRoomDetails(
        null
      ),
      //dostepnosc: new dostepnoscPokoju(
      //  null
      //),
      openDetails: false,
      visible: false,
      openError: false
    }
  }

  openGalery = () => {
    this.setState({ visible: true })
  }

  closeGalery = () => {
    this.setState({ visible: false })
    let body = document.getElementsByTagName("body")[0]
    if(body){
      body.style.overflow = "auto"
      body.style.paddingRight = "0"
    }
  }


  //PM 2021-07-06
  reserve = async () => {
    const minDays = Number(this.props.room.minIloscDni)
    let date: string | undefined;

    if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
      let row1 = this.props.page.grafik.filter(x => Number(this.props.room.id) === x.www_rodz_pokoi_id).map(x => toIloswWAndData(x.dostepna_ilosc_pokoi, x.data))
      const dateRow1Index = row1.findIndex(x => x.iloscW >= 1)
      date = (dateRow1Index !== -1) ? getDate(row1[dateRow1Index], row1, dateRow1Index, minDays) : undefined;
    
    } else if (CONFIG.grafikiRodzaj === "1") {
      let row2 = this.props.page.grafikRodzaje.filter(x => this.props.room.rodzPokoi.trim() === x.rodzPokoi.trim() && x.typ === 3).map(x => toIloswWAndData(x.iloscW, x.data))
      const dateRow2Index = row2.findIndex(x => x.iloscW >= 1)
      date = (dateRow2Index !== -1) ? getDate(row2[dateRow2Index], row2, dateRow2Index, minDays) : undefined;
    
    } else if (CONFIG.grafikiRodzaj === "2") {
      let row3 = this.props.page.grafikNumery.filter(x => this.props.room.pokoj === x.pokoj && x.typ === 3).map(x => toIloswWAndData(x.iloscW, x.data))
      const dateRow3Index = row3.findIndex(x => x.iloscW >= 1)
      date = (dateRow3Index !== -1) ? getDate(row3[dateRow3Index], row3, dateRow3Index, minDays) : undefined;
    }


    //let filteredDates = this.props.page.grafik.filter(x => Number(this.props.room.id) == x.www_rodz_pokoi_id)

    //vscTest
    //console.log(this.props.page.grafik)
    //.log(filteredDates)
    //console.log(date)

    if (date) {
      if (date !== this.props.page.dateFrom) {
        await store.dispatch(Actions.pageState.setDateFromFormularz(date));
        await store.dispatch(Actions.pageState.setDateTo(minDaysLater(date, minDays)));
      } else {
        await store.dispatch(Actions.pageState.setDateFromFormularz(this.props.page.dateFrom));
        await store.dispatch(Actions.pageState.setDateTo(minDaysLater(this.props.page.dateFrom, minDays)));
      }

      await store.dispatch(Actions.pageState.setRoomNumber(this.props.room.pokoj));
      //await store.dispatch(Actions.pageState.restart());
      if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
        let room = this.props.page.roomsOld.find((x => x.www_rodz_pokoi_id === Number(this.props.room.id)))
        if (room) {
          await store.dispatch(Actions.pageState.updateBasketOld(room));
        }
      }
      else {
        let room = this.props.page.rooms.find((x => x.id === String(this.props.room.id)))
        if (room) {
          await store.dispatch(Actions.pageState.updateBasket(room));
        }
      }

      await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
      await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));
    } else {
      this.setState({ openError: true })
    }
  }

  // async getDetails() {
  //   try {
  //     let res: webRoomDetails = await roomsService.getDetails({
  //         hotelId: CONFIG.hotelID,
  //         lang: this.props.lang,
  //         roomCategory: this.props.room.rodz_pokoi,
  //         dateFrom: this.props.dateFrom,
  //         dateTo: this.props.dateTo
  //       })
  //     this.setState({ details: res })  
  //   } catch (error) {
  //     console.error
  //   }

  // }

  // async getDostepnosc() {
  //   try {
  //     let res: Dostepnosc = await bookService.dajDostepnosc({
  //       hotelId: CONFIG.hotelID,
  //       aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //       aRodzPokoiId: this.props.room.www_rodz_pokoi_id,
  //       aDataOd: this.props.dateFrom,
  //       aDataDo: this.props.dateTo
  //     })
  //     if (res.result)
  //       this.setState({dostepnosc: res.result[0]});
  //   } catch (error) {
  //     console.error
  //   }
  // }

  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
    }

  clickDetails() {
    this.setState({ openDetails: true })
  }

  closeDetails = () => {
    this.setState({ openDetails: false })
  };

  closeError = () => {
    this.setState({ openError: false })
  };

  datediff = (first: Date, second: Date): number => {
    return Math.round((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24));
  }

  //PM 2021-07-27
  showOnGraphic = async (room: Room) => {
    if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
      const pokojIndex = this.props.page.roomsOld.findIndex(p => p.www_rodz_pokoi_id === Number(room.id))

      if (pokojIndex !== -1) {
        await store.dispatch(Actions.pageState.setGraphicHighlight(room.id.toString()));

        const grafik = document.getElementById("grafik");

        if (grafik && this.props.page.roomsOld.length > 8) {
          const scrollStep = 436 / (this.props.page.roomsOld.length - 1);

          grafik.scrollTop = scrollStep * (pokojIndex);
        }
      }
    }
    else if (CONFIG.grafikiRodzaj === "1") {
      const pokojIndex = this.props.page.rooms.findIndex(p => p.rodzPokoi === room.rodzPokoi)

      if (pokojIndex !== -1) {
        await store.dispatch(Actions.pageState.setGraphicHighlight(room.rodzPokoi.trim()));

        const grafikRodzajami = document.getElementById("grafik_rodzajami");

        if (grafikRodzajami && this.props.page.rooms.length > 8) {
          const scrollStep = 436 / (this.props.page.rooms.length - 1);

          grafikRodzajami.scrollTop = scrollStep * (pokojIndex);
        }
      }
    }
    else {
      const pokoje = this.props.page.grafikNumery.filter(x => x.typ === 2 && this.props.page.rooms.find(r => r.rodzPokoi === x.rodzPokoi.trim()));
      //vscTest
      //console.log(pokoje)
      const pokoj = pokoje.find(p => p.pokoj === room.pokoj);

      if (pokoj) {
        await store.dispatch(Actions.pageState.setGraphicHighlight(room.pokoj.toString().trim()));

        const numeramiGrafik = document.getElementById("numerami_grafik");

        if (numeramiGrafik && pokoje.length > 8) {
          const scrollStep = 436 / (pokoje.length - 1);

          numeramiGrafik.scrollTop = scrollStep * (pokoj.osY - 1);
        }
      }
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  setPodstrona = async () => {
    await store.dispatch(Actions.pageState.setPodstrona(this.props.podstrona || 0, this.props.room.galleryRodzPokoi)); 
  }

  WartosciPokoju = () => {
    const { classes } = this.props;
    return (
      <Fragment>
        <div style={{ width: this.props.windowWidth <= 1180 ? "100%" : "30%", minWidth: "100px", display: "inline-flex" }}>
          <Typography className={classes.description}>
            <Trans>Price</Trans>:
          </Typography>
          <Typography className={classes.value} color="primary" style={this.textTheme}>
            {this.props.room.cena}
            zł
          </Typography>
        </div>
        <div style={{ width: this.props.windowWidth <= 1180 ? "100%" : "22%", minWidth: "65px", display: "inline-flex" }}>
          <Typography className={classes.description}>
            <Trans>Persons</Trans>:
          </Typography>
          <Typography className={classes.value} color='primary' style={this.textTheme}>
            {this.props.room.iloscMiejsc}
          </Typography>
        </div>
        {/* <div style={{ width: this.state.width <= 1180 ? "100%" : "30%", minWidth: "90px", display: "inline-flex" }}>
        <Typography className={classes.description}>
          <Trans>Available</Trans>:
        </Typography>
        {this.props.pokoje_dostepne ?
          <Typography className={classes.value} color='primary'>
            <Trans>Yes</Trans>
          </Typography>
          :
          <Typography className={classes.value} color="error" >
            <Trans>No</Trans>
          </Typography>
        }
      </div> */}
      </Fragment>
    )

  }

  //PM 2021-07-12
  WartosciPokoju1 = () => {
    const { classes, t } = this.props;

    return (
      <Fragment>
        {this.props.windowWidth > 600 ? 
          <React.Fragment>
            <Typography className={classes.description} style={{ cursor: "pointer", color: this.props.podstrona? "#3a87ad" : "" }} color="primary" onClick={() => { this.props.podstrona ? this.setPodstrona() : this.showOnGraphic(this.props.room) }}>
              <Trans>Price</Trans>{this.props.podstrona ? " " + t("From") : null}<span className={classes.value}  ><b>{" " + this.props.room.cena} zł </b></span><Trans>For</Trans>{" " + this.props.room.ktoraCenaOpis}
            </Typography>
            <br />
          </React.Fragment>
          :
          <React.Fragment>
            <Typography className={classes.description} style={{ cursor: "pointer", color: this.props.podstrona? "#3a87ad" : "" }} color="primary"onClick={() => { this.props.podstrona ? this.setPodstrona() : this.showOnGraphic(this.props.room) }}>
              <Trans>Price</Trans><span className={classes.value}  ><b>{" " + this.props.room.cena} zł</b></span>
            </Typography>
            <Typography className={classes.description} style={{ cursor: "pointer", color: this.props.podstrona? "#3a87ad" : "" }} color="primary" onClick={() => { this.props.podstrona ? this.setPodstrona() : this.showOnGraphic(this.props.room) }}>
              <Trans>Price</Trans>{" "}<Trans>For</Trans>{" "}<span className={classes.value}  ><b>{this.props.room.ktoraCenaOpis}</b></span>
            </Typography>
          </React.Fragment>}


        <Typography className={classes.description} style={{ cursor: "pointer", color: this.props.podstrona? "#3a87ad" : "" }} color="primary" onClick={() => { this.props.podstrona ? this.setPodstrona() : this.showOnGraphic(this.props.room) }}>
          {this.props.windowWidth > 600 ? <Trans>Min days count</Trans> : <Trans>Min days</Trans>}
          <span className={classes.value}  >
            <b>{" " + this.props.room.minIloscDni}</b>
          </span>
        </Typography>


        {/* <Typography className={classes.description} style={{ cursor: "pointer" }} color="primary" onClick={() => { this.showOnGraphic(this.props.room) }}>
          <Trans>{this.props.windowWidth > 600 ? 'Ilość osób min' : 'Osób min'}</Trans>
          <span className={classes.value}  ><b>{" " + "1"}</b></span>
        </Typography> */}

        {this.props.podstrona ?
          // <Typography className={`${classes.description} ${classes.blue}`} style={{ cursor: "pointer", }} color="secondary" onClick={() => { this.setPodstrona() }}>
          //    <Trans>See more</Trans>
          // </Typography>
          <Typography className={classes.description} style={{ cursor: "pointer", color: "#3a87ad" }} color="primary" onClick={() => { this.setPodstrona()  }}>
            {this.props.windowWidth > 600 ? <Trans>Max people count</Trans> : <Trans>Max people</Trans>}
            <span className={classes.value}  ><b>{" " + this.props.room.iloscMiejsc}</b></span>
          </Typography>
          :
          <Typography className={classes.description} style={{ cursor: "pointer" }} color="primary" onClick={() => { this.showOnGraphic(this.props.room)  }}>
            {this.props.windowWidth > 600 ? <Trans>Max people count</Trans> : <Trans>Max people</Trans>}
            <span className={classes.value}  ><b>{" " + this.props.room.iloscMiejsc}</b></span>
          </Typography>
        }

        <br />
        <Typography className={classes.description} color="primary" style={{ paddingBottom: "16px" }}>

        {this.props.podstrona ? 
        <>
          <span style={{ cursor: "pointer" }} className={classes.blue} onClick={() => { this.setPodstrona()  }}>
            {this.props.windowWidth >= 600 ? <Trans>More info</Trans> : <Trans>See more</Trans>}
          </span>
          <MuiThemeProvider theme={themeBlueRed}>
            <Button variant="outlined" color={this.props.pokoje_dostepne ? "primary" : "secondary"} className={this.props.pokoje_dostepne ? `${classes.button} ${classes.confirmBlue}` : `${classes.button} ${classes.notConfirm}`}

              style={{ }}
              onClick={async () => { this.setPodstrona()  }}
            //classes={{ disabled: classes.disabled }}
            //disabled={this.props.pokoje_dostepne}
            >
              <b><Trans>{this.props.pokoje_dostepne ? "Reserve" : "See"}</Trans></b> {/*{this.props.pokoje_dostepne ? "Reserve" : "See"}*/}
            </Button>
           </MuiThemeProvider> 
        </> :
        <> 
          {this.props.windowWidth > 650 ? <span style={{ cursor: "pointer" }} onClick={() => { this.openGalery() }}><Trans>Gallery</Trans>... </span> : null}
          <span style={{ cursor: "pointer" }} onClick={() => { this.clickDetails() }}><Trans>Info</Trans>... </span>
          <span style={{ cursor: "pointer" }} onClick={() => { this.showOnGraphic(this.props.room) }}><Trans>Graphic</Trans>...</span>
          <Button variant="outlined" color="primary" className={this.props.pokoje_dostepne ? `${classes.button} ${classes.confirm}` : `${classes.button} ${classes.notConfirm}`}

            style={{ }}
            onClick={async () => { await this.reserve() }}
          //classes={{ disabled: classes.disabled }}
          //disabled={this.props.pokoje_dostepne}
          >
            <b><Trans>Reserve</Trans></b>
          </Button>
        </>}  

          
        </Typography>

        {/* <div style={{ width: this.props.windowWidth <= 1180 ? "100%" : "30%", minWidth: "100px", display: "inline-flex" }}>
          <Typography className={classes.description}>
            <Trans>Price</Trans>:
        </Typography>
          <Typography className={classes.value} color="primary" style={this.textTheme}>
            {this.props.room.cena} zł
        </Typography>
        </div>
        <div style={{ width: this.props.windowWidth <= 1180 ? "100%" : "22%", minWidth: "65px", display: "inline-flex" }}>
          <Typography className={classes.description}>
            <Trans>Persons</Trans>:
        </Typography>
          <Typography className={classes.value} color='primary' style={this.textTheme}>
            {this.props.room.iloscMiejsc}
          </Typography>
        </div> */}
        {/* <div style={{ width: this.state.width <= 1180 ? "100%" : "30%", minWidth: "90px", display: "inline-flex" }}>
        <Typography className={classes.description}>
          <Trans>Available</Trans>:
        </Typography>
        {this.props.pokoje_dostepne ?
          <Typography className={classes.value} color='primary'>
            <Trans>Yes</Trans>
          </Typography>
          :
          <Typography className={classes.value} color="error" >
            <Trans>No</Trans>
          </Typography>
        }
      </div> */}
      </Fragment>
    )

  }

  WartosciPokoju9999 = () => {
    const { classes } = this.props;

    return (
      <Fragment>
        <React.Fragment>
            <Typography className={classes.description} style={{ cursor: "pointer" }} color="primary" onClick={() => { }}>
              {"ㅤ"}<span className={classes.value}  ><b>{"ㅤ"}</b></span>
            </Typography>
            <br />
        </React.Fragment>
        <Typography className={classes.description} style={{ cursor: "pointer" }} color="primary" onClick={() => { }}>
          {'ㅤ'}<span className={classes.value}  ><b>{"ㅤ"}</b></span>
        </Typography>
        <Typography className={classes.description} style={{ cursor: "pointer" }} color="primary" onClick={() => { }}>
          {"ㅤ"}<span className={classes.value}  ><b>{"ㅤ"}</b></span>
        </Typography>
        <br />
        <Typography className={classes.description} color="primary" style={{ paddingBottom: "16px" }}>
          {this.props.windowWidth > 650 ? <span style={{ cursor: "pointer" }} onClick={() => { }}>{'ㅤ'}</span> : null}
          <span style={{ cursor: "pointer" }} onClick={() => {  }}>{'ㅤ'}</span>
          <span style={{ cursor: "pointer" }} onClick={() => {  }}>{'ㅤ'}</span>

          {this.props.page.podstrona ? 
          <Button variant="outlined" color="primary" className={`${classes.button} ${classes.notConfirm}`}

          style={{  }}
          onClick={async () => { await store.dispatch(Actions.pageState.setPodstrona(0, ''));  }}
        >
          <b><Trans>Back</Trans></b>
        </Button>
        :
        <Button variant="outlined" color="primary" className={`${classes.button} ${classes.notConfirm}`}

            style={{  }}
            onClick={async () => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          >
            <b><Trans>Home</Trans></b>
          </Button>
          }
          
        </Typography>
      </Fragment>
    )

  }


  getGrid = () => {
    const { t, classes } = this.props;

    if( this.props.room.id != 9999){
      const fotoUrl = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/${this.props.room.galleryRodzPokoi}/th_foto.jpg`
      return <Grid container  >
        <Grid item xs={12} style={{ paddingBottom: "0px", display: "flex" }}>
          <div
          style={{ width: "calc(52%)", margin: "6px 12px 6px 8px" }}
          className={`${classes.media} ${classes.imageSize}`}>
          <CardMedia
            style={{maxHeight: "100%", maxWidth: "100%", width: "100%", height: "100%", objectFit: "fill", aspectRatio: "10/9" }}
            image={fotoUrl}
            //src={fotoUrl}
            title={this.props.room.opis}
            onClick={() => { this.props.podstrona ? this.setPodstrona() : this.openGalery() }}
            onError={this.ImgError}
            component="img"
          /></div>
          <div style={{ width: '48%', paddingRight: "10px", position: "relative", height: "fit-content" }}>
            <div>
              <Typography gutterBottom component="h6" color="primary"
                className={`${classes.headline}`}>
                <b style={{...this.textTheme, color: this.props.podstrona? "#3a87ad" : "" }}>{this.props.room.opis}</b>
              </Typography>
              <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
              <div className={classes.padding} style={{  }}>
                {this.WartosciPokoju1()}
              </div>
              {/* <div style={{ marginLeft: "-4px", textAlign: "end", paddingBottom: "8px" }}>

                <Button variant="outlined" color="primary" className={`${classes.confirm} ${classes.button}`}
                  
                  onClick={async () => { await this.reserve() }}
                  classes={{ disabled: classes.disabled }}
                >
                  <b><Trans>Reserve</Trans></b>
                </Button>
              </div> */}
              {/* disabled={(this.state.dostepnosc  this.props.pokoje_dostepne) ? false : true} */}
              {/* <div style={{ position: "absolute", bottom: "8px" }}>
                <Button variant="outlined" color="primary" className={`${classes.confirm} ${classes.button}`}
                  
                  style={{}}
                  onClick={async () => { await this.reserve() }}
                  classes={{ disabled: classes.disabled }}
                >
                  <b><Trans>Reserve</Trans></b>
                </Button>
                <Button variant="outlined" color="primary" className={classes.button}
                  style={{ marginLeft: "8px" }}
                  onClick={() => { this.clickDetails() }}
                >
                  <Trans>Details</Trans>
                </Button>
                {this.props.windowWidth > 1370 ?
                  <Button variant="outlined" color="primary" className={classes.button}
                    style={{ marginLeft: "8px" }}
                    onClick={this.openGalery}>
                    <Trans>Photos</Trans>
                  </Button>
                  : null}
              </div> */}
            </div>

          </div>
        </Grid>
    </Grid>
    }else{ // mz 2022-06-15 dodajemy dummy pokój dla nieparzystych
      const fotoUrl = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/${this.props.room.galleryRodzPokoi}.jpg`
      return <Grid container  >
        <Grid item xs={12} style={{ paddingBottom: "0px", display: "flex" }}>
          <div
          style={{ width: "calc(52%)", margin: "6px 12px 6px 8px" }}
          className={`${classes.media} ${classes.imageSize}`}>
          <CardMedia
            style={{maxHeight: "100%", maxWidth: "100%", width: "100%", height: "100%", objectFit: "fill", aspectRatio: "10/9" }}
            image={fotoUrl}
            //src={fotoUrl}
            title={this.props.room.opis}
            onClick={() => { this.openGalery() }}
            onError={this.ImgError}
            component="img"
          /></div>
          <div style={{ width: '48%', paddingRight: "10px", position: "relative", height: "fit-content" }}>
            <div>
              <Typography gutterBottom component="h6" color="primary"
                className={`${classes.headline}`}>
                <b style={this.textTheme}>{this.props.room.opis}</b>
              </Typography>
              <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
              <div className={classes.padding} style={{  }}>
                {this.WartosciPokoju9999()}
              </div>
            </div>

          </div>
        </Grid>
    </Grid>
    }
  }
 


  //PM 2021-07-07
  render() {
    const { t, classes } = this.props;
    this.avatar = <Avatar aria-label="Recipe" className={classes.avatarg}> </Avatar>
    const lPhotos = t('Photos')
    const fotoUrl = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/${this.props.room.galleryRodzPokoi}/th_foto.jpg`
    //let long : string = this.props.room.long ? this.props.room.long:"";

    return (
      <Paper className={classes.paper} elevation={0}>
        <Card
          elevation={4}
          style={{ background: "linear-gradient(to bottom, #ffffff, #f7f7f7)" }}> 
          {/* , borderLeft: this.props.borderLeft, borderBottom: this.props.borderLeft, */}

          {this.props.windowWidth > 100 ?
            <div> {this.getGrid()} </div>
            :
            <Grid >
              <Grid item xs={12} style={{ paddingBottom: "0px", display: "flex" }}>
                <div>
                  <CardMedia
                    style={{ width: "150px", height: "84px", margin: "6px 16px 6px 8px" }}
                    className={classes.media}
                    image={fotoUrl}
                    title={this.props.room.opis}
                    onClick={() => this.setState({ visible: true })}
                  />
                  {/* <CardActions className={classes.actions}
                    style={{ padding: "1px", margin: "0px 16px 0px 8px", justifyContent: "space-around" }}>
                    <Button variant="outlined" color="primary" className={`${classes.confirm} ${classes.button}`}
                      
                      style={{ width: "45%" }}
                      onClick={async () => { await this.reserve() }}
                      classes={{ disabled: classes.disabled }}
                    >
                      <b><Trans>Reserve</Trans></b>
                    </Button>
                    <Button variant="outlined" color="primary" className={classes.button}
                      style={{ width: "45%", marginLeft: "8px" }}
                      onClick={() => { this.clickDetails() }}
                    >
                      <Trans>Details</Trans>
                    </Button>
                  </CardActions> */}
                </div>
                <div style={{ width: 'calc(100% - 160px)', paddingRight: "10px" }}>
                  <Typography gutterBottom component="h6" color="primary"
                    className={`${classes.headline}`}  style={{...this.textTheme, color: this.props.podstrona? "#3a87ad" : "" }}>
                    {this.props.room.opis}
                  </Typography>
                  <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                  <div style={{ paddingLeft: "16px", paddingTop: "6px" }}>
                    {this.WartosciPokoju1()}
                  </div>
                </div>
              </Grid>
            </Grid>}
        </Card>
        <Gallery className={classes.actions} button={true} title={lPhotos} visible={this.state.visible} close={this.closeGalery}
          icon="icon-picture" room={this.props.room.galleryRodzPokoi} />
        {this.state.openDetails ?
          <Details
            details={{
              info: this.props.room.info,
              opis: this.props.room.opis,
              cena: this.props.room.cena,
              cenaZa: this.props.room.ktoraCenaOpis,
              dniMin: this.props.room.minIloscDni,
              osobMax: this.props.room.iloscMiejsc,
            }}
            open={this.state.openDetails}
            close={this.closeDetails} 
            pokoje_dostepne={this.props.pokoje_dostepne}
            room={this.props.room}
            windowWidth={this.props.windowWidth}/> : null}

      <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }>
        <Dialog
          fullWidth
          //fullScreen={this.state.fullScreen}
          maxWidth="xs"
          open={this.state.openError}
          aria-labelledby="responsive-dialog-title"
        >
          {/* <Paper className={"Paper"} elevation={2} classes={{root: classes.paper}}></Paper>   */}
          <DialogTitle disableTypography>
            <Typography variant="h6" component="h2" color="error">
              <b> <Trans>Warning</Trans></b>
            </Typography>
            <hr />
          </DialogTitle>
          <DialogContent>

            <DialogContentText style={{ paddingLeft: "15px" }}>
              <Typography variant="body1" component="h2">
                W podanym okresie brak wolnych miejsc dla <br /><b className={classes.secondary}>{this.props.room.opis}</b>
              </Typography>
              <Typography >

              </Typography>
              <Typography>
                {/* className={classes.dialogText}> */}

              </Typography>


            </DialogContentText>
            {/* <DialogContentText style={{ whiteSpace: "pre" }}>
            
            </DialogContentText> 
            <DialogContentText style={{ whiteSpace: "pre" }}>
              {"   "}
              
                <b className={classes.secondary}><Trans>Agin</Trans></b>
            </DialogContentText> 
            <DialogContentText style={{ whiteSpace: "pre" }}>
              {"   "}
             
                <b className={classes.secondary}><Trans>Phone Contact</Trans></b>
            </DialogContentText>  */}







          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="secondary" size="small"
              onClick={this.closeError}>
              <b style={{ textTransform: "lowercase" }}><Trans>Back</Trans></b>
            </Button>
          </DialogActions>
          {/* </Paper>     */}
        </Dialog>
        </MuiThemeProvider>

      </Paper>
    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    marginBottom: "1em",
  },
  media: {
    cursor: "pointer",
    border: "5px solid #fff",
    boxShadow: "2px 2px 3px 2px #e6e6e6",
  },
  button: {
    textTransform: 'none' as "none",
    lineHeight: "13px",
    fontSize: "11px",
    padding: "6px 8px 5px 8px",
    borderRadius: "0",
    float: "right" as "right", 
    marginBottom: "8px", 
    "@media (min-width: 1000px) and (max-width: 1212px)": {
      marginTop: "5px"
    },
    marginTop: "-2px"
  },
  imageSize: {
    height: "164px",
    maxHeight: "168px",
   
    "@media (min-width: 600px)": {
      height: "calc(100% - 22px)"
    },
    "@media (min-width: 1000px) and (max-width: 1212px)": {
      maxHeight: "100%",
    },

  },
  padding: {
    paddingLeft: "16px", 
    paddingTop: "6px", 
    minHeight: "94px",
   
    "@media (min-width: 600px)": {
      paddingLeft: "10px"
    },
    "@media (min-width: 1000px) and (max-width: 1212px)": {
      paddingLeft: "10px",
    },
   
  },
  confirm: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom," + theme.palette.primary.dark + ", " + theme.palette.primary.main + ")",
  },
  confirmBlue: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom," + "rgba(58, 135, 173, 0.7)" + ", " + "#3a87ad" + ")",
  },
  notConfirm: {
    //color: "#ffffff",
    //textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    //background: "linear-gradient(to bottom," + theme.palette.primary.dark + ", " + theme.palette.primary.main + ")",
  },
  description: {
    //paddingRight: "5px",
    fontSize: "12px",
    fontWeight: 400,
    //color: "#555",
    lineHeight: "20px"
  },
  value: {
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: "bold" as "bold"
  },
  error: {
    color: theme.palette.error.main
  },
  secondary: {
    color: theme.palette.secondary.main,
    whiteSpace: "pre" as "pre"
  },
  blue: {
    color: "#3a87ad"
  },
  actions: {
    display: 'flex',
    height: "42px"
  },
  disabled: {
    background: "#ffffff",
    textIndent: "-9999px"
    //whiteSpace: "nowrap",
    //overflow: "hidden"
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "12px",
    //fontWeight: 600,
    margin: "10px 0"
  },
  avatarg: {
    backgroundColor: green[500],
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(RoomCard)));